// Radha — the real "pay this invoice" action: opens Razorpay Checkout, waits
// for the webhook-confirmed capture, and reports back plainly. Supports an
// optional partial amount (defaults to the full outstanding balance) and an
// optional installment id (paying one step of a payment plan).
import React, { useState } from "react";

import { usePayInvoice, payErrorMessage } from "../hooks/usePayments";
import { fmtMoney as inr } from "../lib/money";


export function PayButton({
  invoiceId, outstanding, tenantName, installmentId, amount, label,
}: {
  invoiceId: string; outstanding: number; tenantName: string;
  installmentId?: string; amount?: number; label?: string;
}) {
  const pay = usePayInvoice(tenantName);
  const [note, setNote] = useState<{ ok: boolean; text: string } | null>(null);

  const doPay = () => {
    setNote(null);
    pay.mutate(
      { invoiceId, installmentId, amount },
      {
        onSuccess: (p) => setNote(
          p.status === "captured"
            ? { ok: true, text: `Paid ${inr(Number(p.amount))}` }
            : { ok: false, text: p.failure_reason ?? "Payment failed" },
        ),
        onError: (e) => setNote({ ok: false, text: payErrorMessage(e) }),
      },
    );
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <button
        onClick={doPay}
        disabled={pay.isPending || outstanding <= 0}
        style={{
          padding: "4px 12px", fontSize: 12, fontWeight: 600, color: "#fff",
          background: pay.isPending ? "var(--fg-faint)" : "var(--accent-purple)",
          border: 0, borderRadius: 6, cursor: pay.isPending ? "default" : "pointer",
        }}
      >
        {pay.isPending ? "Confirming…" : label ?? `Pay ${inr(amount ?? outstanding)}`}
      </button>
      {note && (
        <span style={{ fontSize: 12, color: note.ok ? "var(--status-good)" : "var(--status-critical)" }}>
          {note.text}
        </span>
      )}
    </span>
  );
}
